module.exports = __webpack_public_path__ + "static/media/quickstart-step-1.01e39c24.jpg";